<template>
  <div style="display: flex;align-items: center;">
    <span style="color:#248cfa;">{{item.text}}：</span>
    <div v-if="item.type == 3">
      <el-time-picker
          style="width: 130px;"
          :clearable="false"
          arrow-control
          @blur="onChange"
          @change="onChange"
          size="mini"
          v-model="item.value"
          placeholder="请选择时间">
      </el-time-picker>
    </div>
    <div v-else-if="item.type == 4 || item.type == 6">
      <time-picker  v-model="item.value" :isFuture = "item.type == 6"></time-picker>
    </div>
    <div v-else-if="item.type == 5 || item.type == 7">
      <timePickerGroupN v-model="item.value" :isFuture = "item.type == 7"></timePickerGroupN>
    </div>
  </div>
</template>

<script> //
import timePickerNew from "../../../questionItenByTypes/timePickerNew";
import timePicker from "./dateTimePickerN";
import timePickerGroupN from "./timePickerGroupN";
import moment from "moment";
export default {
  name: "dateTime",
  props: ['item','timeSelectOptions'],
  components: {
    timePickerNew,
    timePickerGroupN,
    timePicker
  },
  methods: {
    onChange(value) {
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>